export default "__VITE_ASSET__BdA9pLHg__"